// import InputGroup from "../../../../components/FormComponent/InputGroup";
// import Layout from "../../../../components/Layout";
// import BreadCrumb from "../../../../components/BreadCrumb";
// // import { ToastContainer } from "react-toastify";
import Button from "../../../../components/Button";
import useStyles from "../../styles";
// import { useUserState } from "../../../../context/UserContext";
import logo from "../../../../assets/images/logo.svg";
import { toast } from "react-toastify";
import InputGroup from "../../../../components/FormComponent/InputGroup";
import PaymentRow from "./PaymentRow";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Grid,
  Paper
} from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useParams, useNavigate } from "react-router-dom";
import { httprequest } from "../../../../data/api";
import { useEffect, useState } from "react";
import Modal from "../../../../components/Modal";
import PageLoader from "../../../../components/PageLoader";
import useValidator from "../../../../hooks/useValidator";

const STUDENT_INVOICE = "/api/v1/invoices/student-invoices";
const PAY_INVOICE = "/api/v1/invoices/student-invoices/";

const PayInvoice = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const classes = useStyles();
  const [amountValidator, showAmountValidator] = useValidator();
  // const { appLogo, profile } = useUserState();
  const [cancelModal, setCancelModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [invoice, setInvoice] = useState({});
  const [copiedAccount, setCopiedAccount] = useState(null);
  // const [paymentDetails, setPaymentDetails] = useState({});
  const [isDirecting, setIsRedirecting] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [payAmount, setPayAmount] = useState({
    amount: 0
  });

  const handleCopyAccountNumber = async (accountNumber, bankId) => {
    await navigator.clipboard.writeText(accountNumber);
    setCopiedAccount(bankId);

    setTimeout(() => setCopiedAccount(null), 2000);
  };

  const handlePaymentModal = () => {
    setPaymentModal(!paymentModal);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPayAmount((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const closeHandlePaymentModal = () => {
    setPaymentModal(false);
    setPayAmount({
      amount: ""
    });
  };

  /**
 * Fetches the status of a specific invoice
 * @function getViewInvoiceStatus
 * @async
 * @description Retrieves invoice details from the server and updates state
 * @throws {Error} If the request fails, silently catches and stops loading
 */
  const getPaymentURL = () => {
    setIsRedirecting(true);
    if (amountValidator.allValid()) {
      httprequest
        .post(`${PAY_INVOICE}${id}/pay`, payAmount)
        .then((res) => {
          if (res?.data?.data?.redirect_url) {
            window.location.href = res?.data?.data?.redirect_url;
            toast.success(res?.data?.data?.message);
          } else {
            toast.error(res?.response?.data?.message || "Failed to get payment link");
          }
          setIsRedirecting(false);
        }).catch((res) => {
          setIsRedirecting(false);
          toast.error(res?.response?.data?.message);
        });
    } else {
      showAmountValidator(true);
      setIsRedirecting(false);
    }
  };

  /**
 * Fetches the status of a specific invoice
 * @function getViewInvoiceStatus
 * @async
 * @description Retrieves invoice details from the server and updates state
 * @throws {Error} If the request fails, silently catches and stops loading
 */
  const getViewInvoiceStatus = () => {
    setIsLoading(true);
    httprequest
      .get(`${STUDENT_INVOICE}/${id}`)
      .then((res) => {
        setInvoice(res?.data?.data);
        setIsLoading(false);
      }).catch((res) => {
        setIsLoading(false);
        toast.error(res?.data?.response?.message);
      });
  };

  /**
 * Fetches payment link and redirects to payment gateway
 * @function fetchAndRedirectToPayment
 * @async
 * @description Handles the payment redirection flow with error handling
 * @throws {Error} Displays error toast if payment link is missing or request fails
 * @returns {Promise<void>}
 */
  // const fetchAndRedirectToPayment = async () => {
  //   setIsRedirecting(true);
  //   try {
  //     const url = invoice?.payment_link;
  //     if (!url) {
  //       toast.error("sorry payment link is missing");
  //       setIsRedirecting(false);

  //       return;
  //     }

  //     const res = await httprequest.get(url);

  //     // Check the response structure to ensure redirect_url exists
  //     if (res?.data?.data?.redirect_url) {
  //       window.location.href = res?.data?.data?.redirect_url;
  //       toast.success(res?.data?.data?.message);
  //     } else {
  //       toast.error(res?.data?.message || "Failed to get payment link");
  //     }
  //   } catch (error) {
  //     toast.error(error?.response?.data?.message);
  //   } finally {
  //     setIsRedirecting(false);
  //   }
  // };

  /**
 * Closes the cancel modal and navigates back to invoices list
 * @function handleCloseCancelModal
 * @description Handles modal closure and navigation
 */
  const handleCloseCancelModal = () => {
    setCancelModal(false);
    navigate("/payment/invoice");
  };

  /**
 * Fetches invoice status on component mount
 * @effect
 * @listens Mount
 * @description Initial data loading when component is mounted
 */
  useEffect(() => {
    getViewInvoiceStatus();
  }, []);

  // const total = payments.reduce((sum, payment) => sum + payment?.amount, 0);

  return (
    <div className={classes.invoicemain}>
      <div className={classes.marginitem}>
        <div className="page-content padding-equal">
          {isLoading ? <PageLoader /> : (
            <>
              <div className={`${classes.previewheader} margin-bottom-30`}>
                <div className={classes.logoContent}>
                  <img
                    src={logo}
                    alt="App Logo"
                    className={classes.logoContent}
                  />
                </div>
                <div className="flex gap-10 align-items-center flex-item-reverse-413">
                  <div className={`${classes.paymentBadge} ${
                    invoice?.status === "paid" ? classes.paid :
                      invoice?.status === "partly_paid" ? classes.partlyPaid :
                        invoice?.status === "overpayment" ? classes.overpaid :
                          classes.unpaid
                  }`}
                  >
                    <span className={classes.badgeIcon}>
                      {invoice?.status === "paid" ? "✓" :
                        invoice?.status === "partly_paid" ? "◔" :
                          invoice?.status === "overpayment" ? "⤴" :
                            "!"}
                    </span>
                    {invoice?.status === "paid" ? "Paid" :
                      invoice?.status === "partly_paid" ? "Partly Paid" :
                        invoice?.status === "overpayment" ? "Overpaid" :
                          "Unpaid"}
                  </div>
                  <div className="text-align-left-413 text-align-right">
                    <p>Invoice Number</p>
                    <h4>#{invoice?.invoice_no || "--/--"}</h4>
                  </div>
                </div>
              </div>
              <div className={`${classes.previewheader} margin-bottom-14`}>
                <div>
                  <p className="text-align-left">Invoice Name</p>
                  <h4>{invoice?.invoice_name || "--/--"}</h4>
                </div>
                <div className="text-align-right">
                  <p className="text-align-left-413">Total Payable</p>
                  <h6>{`${invoice?.total?.toLocaleString() || "0.00"} ${invoice?.payment_method?.[0]?.currency || "NGN"}`}</h6>
                </div>
              </div>
              <div>
                <div className={classes.previewheader}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Session</p>
                      <h4>{invoice?.session?.name || "--/--"}</h4>
                    </div>
                  </div>
                  <div className={`${classes.previewsubheader} text-align-auto`}>
                    <div>
                      <p>Term</p>
                      <h4>{invoice?.term?.name || "--/--"}</h4>
                    </div>
                  </div>
                </div>
                {/* <div className={`${classes.previewsubheader} text-align-auto`}>
                  <div>
                    <p>Pay To</p>
                    <h4>{profile?.school_name || "--/--"}</h4>
                    <small>{profile?.address}</small>
                  </div>
                </div> */}
              </div>
              <div className={classes.previewheader}>
                <div className={`${classes.previewsubheader} text-align-left`}>
                  <div>
                    <p>Invoiced To</p>
                    <h4 className="text-align-left">
                      {invoice?.structure_type === "student" ? (
                        <>
                          {`${invoice?.student?.last_name || "--/--"} ${invoice?.student?.first_name || "--/--"}`}
                        </>
                      ) : invoice?.structure_type === "subject" ? (
                        <>
                          {invoice?.subject?.name || "--/--"}
                        </>
                      ) : invoice?.structure_type === "class" ? (
                        invoice?.classes?.map((all, i) => {
                          return (
                            <h4 className="key-pair-value" key={i}>{`${all?.name || "--/--"}`}</h4>
                          );
                        })
                      ) : null}
                    </h4>
                  </div>
                </div>
                <div className={`${classes.previewsubheader} text-align-auto`}>
                  <div className={`${classes.previewsubheader}`}>
                    <div>
                      <p>Due On</p>
                      <h4>{invoice?.due_date || "--/--"}</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`${classes.previewsubheader}  text-align-left`}>
                <div>
                  <p>Created On</p>
                  <h4>{invoice?.created_at || "--/--"}</h4>
                </div>
              </div>
              <TableContainer component={Paper} style={{ overflowX: "auto", marginTop: "40px" }} className="payment-table">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Item</TableCell>
                      <TableCell></TableCell>
                      <TableCell>Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ textAlign: "left" }}>
                    {invoice?.fee_items?.map((payment, index) => (
                      <PaymentRow
                        key={index}
                        item={payment?.item || "--/--"}
                        amount={payment?.amount}
                      />
                    ))}
                  </TableBody>
                  <TableFooter style={{ backgroundColor: "#F9FAFB" }}>
                    <TableRow>
                      <TableCell colSpan={2} style={{ textAlign: "left", fontWeight: "700", fontSize: "14px", padding: "24px" }}>
      Total
                      </TableCell>
                      <TableCell className={classes.invoiceSummary}>
                        <div className={classes.summarContainer}>
                          <div className={classes.summaryItem}>
                            <span>Sub Total:</span>
                            <strong>{`${invoice?.currency || "N"} ${invoice?.total?.toLocaleString() || 0.00}`}</strong>
                          </div>
                          <div className={classes.summaryItem}>
                            <span>Discount:</span>
                            <strong>{`${invoice?.currency || "N"} ${invoice?.discount_value?.toLocaleString() || 0.00}`}</strong>
                          </div>
                          <div className={`${classes.summaryItem} ${classes.grand}`}>
                            <span>Grand Total:</span>
                            <strong>{`${invoice?.currency || "N"} ${invoice?.amount_payable?.toLocaleString() || 0.00}`}</strong>
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
              {invoice?.offline_payment_methods?.length > 0 && (
                <div className={classes.paymentInstructions}>
                  <div className={classes.paymentHeader}>
                    <Icon icon="mdi:bank-transfer" width="24" height="24" />
                    <h3 className={classes.paymentTitle}>Bank Transfer Instructions</h3>
                  </div>

                  <p className={classes.paymentSubtitle}>
    You can make payment directly into any of our bank accounts below
                  </p>

                  <div className={classes.bankAccountsGrid}>
                    {invoice?.offline_payment_methods?.map((bank, index) => (
                      <div key={index} className={classes.bankAccountCard}>
                        <div className={classes.bankCardHeader}>
                          <div className={classes.bankInfo}>
                            <Icon icon="mdi:bank" width="20" height="20" />
                            <span className={classes.bankName}>{bank?.bank_name}</span>
                            {bank?.is_primary && (
                              <span className={classes.primaryTag}>Recommended</span>
                            )}
                          </div>
                          <div className={classes.currencyBadge}>
                            {bank?.currency}
                          </div>
                        </div>

                        <div className={classes.accountDetails}>
                          <div className={classes.detailRow}>
                            <span className={classes.detailLabel}>Account Name:</span>
                            <span className={classes.detailValue}>{bank?.account_name}</span>
                          </div>
                          <div className={classes.detailRow}>
                            <span className={classes.detailLabel}>Account Number:</span>
                            <div className={classes.copyContainer}>
                              <div className={classes.detailValue}>{bank?.account_number}</div>
                              <div
                                className={classes.copyIcon}
                                onClick={() => handleCopyAccountNumber(bank?.account_number, bank?.id)}
                                title="Copy account number"
                              >
                                {copiedAccount === bank?.id ? (
                                  <Icon icon="mdi:check" width="16" height="16" />
                                ) : (
                                  <Icon icon="mdi:content-copy" width="16" height="16" />
                                )}
                              </div>
                            </div>
                          </div>
                          <div className={classes.detailRow}>
                            <span className={classes.detailLabel}>Currency:</span>
                            <span className={classes.detailValue}>{bank?.currency}</span>
                          </div>
                        </div>

                        {bank?.is_verified && (
                          <div className={classes.verifiedBadge}>
                            <Icon icon="mdi:check-decagram" width="16" height="16" />
            Verified Account
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className={classes.paymentNotes}>
                    <div className={classes.noteItem}>
                      <Icon icon="mdi:information" width="18" height="18" />
                      <span>Please use your name as payment reference</span>
                    </div>
                    <div className={classes.noteItem}>
                      <Icon icon="mdi:clock-outline" width="18" height="18" />
                      <span>Payments are processed within 24 hours</span>
                    </div>
                    <div className={classes.noteItem}>
                      <Icon icon="mdi:shield-check" width="18" height="18" />
                      <span>Your payment is secure and protected</span>
                    </div>
                  </div>

                </div>
              )}
              <div className={`${classes.previewsubheader} text-align-left margin-top-30 `}>
                <div>
                  <div className="margin-bottom-14">
                    <p>Description:</p>
                    <p>{invoice?.description || "--/--"}</p>
                  </div>
                  <div className={`${classes.previewheader} margin-bottom-14`}>
                    <h6 onClick={() => window.print()} className="cursor-pointer">Print Invoice 🖨</h6>
                  </div>
                </div>
                <div>
                  {((invoice?.status === "unpaid" || invoice?.status === "partly_paid") && invoice?.online_payment_method !== null) && (
                    <>
                      {/* <p className="margin-bottom-18">Payment Link</p> */}
                      <div>
                        <Button
                          variant="primaryoutline"
                          buttonSize="medium"
                          color="btnfontprimary"
                          buttonName="Make Payment"
                          onClick={handlePaymentModal}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        <Modal
          title="Cancel"
          subtitle={
            <div>
            Are you sure you want to cancel ?
            </div>
          }
          modalContent={<></>}
          modalFooter={
            <>
              <div className="flex gap-10">
                <Button
                  variant="dangeroutline"
                  buttonSize="full"
                  color="btndanger"
                  buttonName="Go Back"
                  onClick={handleCloseCancelModal}
                />
                <Button
                  variant="danger"
                  buttonName="Yes, Cancel"
                  buttonSize="full"
                  color="btndefault"
                  onClick={() => navigate("/payment/overview")}
                />
              </div>
            </>
          }
          isopen={cancelModal}
          closeModal={handleCloseCancelModal}
        />
        {/* Add a Transaction */}
        <Modal
          title="Make Payment"
          subtitle={
            <div>
                        Manually record a payment received in cash for tuition, fees, or other charges.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Amount to Pay"
                    margin="normal"
                    placeHolder="Enter Amount"
                    inputType="nummber"
                    inputName="amount"
                    onChange={handleChange}
                  />
                  {amountValidator.message("Amount", payAmount?.amount, "required|min:0.01")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <Button
                variant="primary"
                buttonName={isDirecting ? "Redirecting..." : "Proceed to Pay"}
                buttonSize="full"
                color="btndefault"
                onClick={getPaymentURL}
                // isLoading={addTransactionIsLoading}
              />
            </>
          }
          isopen={paymentModal}
          closeModal={closeHandlePaymentModal}
        />
      </div>
      {/* <ToastContainer /> */}
    </div>
  );
};

export default PayInvoice;
